"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpotlightedVenueDto = void 0;
const swagger_1 = require("@nestjs/swagger");
const spotlight_badge_priority_1 = require("../../utils/spotlight-badge-priority");
class SpotlightedVenueDto {
  constructor() {
    this.hasSpecial = false;
    this.isSponsored = false;
    this.isTrending = false;
    this.hasActiveEvent = false;
    this.hasActiveCheckin = false;
    this.hasActiveStickers = false;
    this.isCurrentVenue = false;
  }
}
exports.SpotlightedVenueDto = SpotlightedVenueDto;
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Object)], SpotlightedVenueDto.prototype, "publicId", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Object)], SpotlightedVenueDto.prototype, "latitude", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Object)], SpotlightedVenueDto.prototype, "longitude", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], SpotlightedVenueDto.prototype, "name", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], SpotlightedVenueDto.prototype, "details", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Boolean)], SpotlightedVenueDto.prototype, "hasSpecial", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Venue has an admin-scheduled sponsored period covering right now, within the search radius.'
}), __metadata("design:type", Boolean)], SpotlightedVenueDto.prototype, "isSponsored", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Venue qualifies as Trending per spotlightTrending admin rules (Popular Today / check-ins per day).'
}), __metadata("design:type", Boolean)], SpotlightedVenueDto.prototype, "isTrending", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Venue has special/event content active right now (date, time, and day-of-week window).'
}), __metadata("design:type", Boolean)], SpotlightedVenueDto.prototype, "hasActiveEvent", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'At least one user is checked in at the venue right now (live count from current_venue_id).'
}), __metadata("design:type", Boolean)], SpotlightedVenueDto.prototype, "hasActiveCheckin", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Venue has active (non-expired) stickers posted right now.'
}), __metadata("design:type", Boolean)], SpotlightedVenueDto.prototype, "hasActiveStickers", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "This is the user's current checked-in venue."
}), __metadata("design:type", Boolean)], SpotlightedVenueDto.prototype, "isCurrentVenue", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  description: 'Check-ins today (server timezone).'
}), __metadata("design:type", Object)], SpotlightedVenueDto.prototype, "checkInsTodayCount", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  nullable: true,
  enum: spotlight_badge_priority_1.SPOTLIGHT_BADGE_CATEGORIES,
  description: 'Which single category (if any) the ticker card should badge as, per the admin-configured ' + 'spotlightBadgePriority order applied to the boolean flags above. Null when none apply (standard card).'
}), __metadata("design:type", Object)], SpotlightedVenueDto.prototype, "badgeCategory", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true
}), __metadata("design:type", Object)], SpotlightedVenueDto.prototype, "postalCode", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  description: 'When true, the venue should be hidden from map/discovery surfaces.'
}), __metadata("design:type", Object)], SpotlightedVenueDto.prototype, "isHidden", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  description: 'When true, the venue is permanently closed for visits (soft-close).'
}), __metadata("design:type", Object)], SpotlightedVenueDto.prototype, "isClosed", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false
}), __metadata("design:type", Object)], SpotlightedVenueDto.prototype, "totalCheckins", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false
}), __metadata("design:type", Object)], SpotlightedVenueDto.prototype, "matchingCheckins", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  description: "RSVPs to active community events (venue specials) at this venue."
}), __metadata("design:type", Object)], SpotlightedVenueDto.prototype, "eventRsvpCount", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  description: "Personal visit plans for today at this venue (server timezone)."
}), __metadata("design:type", Object)], SpotlightedVenueDto.prototype, "visitPlanCount", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false
}), __metadata("design:type", Object)], SpotlightedVenueDto.prototype, "breadcrumbsCount", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  description: 'Alias of breadcrumbsCount for parity with VenueDto.'
}), __metadata("design:type", Object)], SpotlightedVenueDto.prototype, "breadcrumbCount", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  description: 'Count of active (non-expired, non-deleted) stickers posted at this venue.'
}), __metadata("design:type", Object)], SpotlightedVenueDto.prototype, "stickersCount", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  description: 'Alias of stickersCount for parity with VenueDto.stickerCount.'
}), __metadata("design:type", Object)], SpotlightedVenueDto.prototype, "stickerCount", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  description: 'Distinct users who viewed recently (last 7 days).'
}), __metadata("design:type", Object)], SpotlightedVenueDto.prototype, "interestedUsers", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  description: 'Alias of interestedUsers for parity with VenueDto.peeks.'
}), __metadata("design:type", Object)], SpotlightedVenueDto.prototype, "peeks", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  description: 'Number of check-ins in the last 14 days (based on Visit.checkedInAt).'
}), __metadata("design:type", Object)], SpotlightedVenueDto.prototype, "recentCheckins", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], SpotlightedVenueDto.prototype, "logoUrl", void 0);
//# sourceMappingURL=SpotlightedVenue.dto.js.map